// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/request_schema/v1/request_schema.proto" (package "c1.api.request_schema.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { RequestSchemaService } from "./request_schema";
import type { RequestSchemaServiceCountBindingsForSchemaResponse } from "./request_schema";
import type { RequestSchemaServiceCountBindingsForSchemaRequest } from "./request_schema";
import type { RequestSchemaServiceFindForAppEntitlementsResponse } from "./request_schema";
import type { RequestSchemaServiceFindForAppEntitlementsRequest } from "./request_schema";
import type { RequestSchemaServiceUpdateBindingsResponse } from "./request_schema";
import type { RequestSchemaServiceUpdateBindingsRequest } from "./request_schema";
import type { RequestSchemaServiceFindBindingForAppEntitlementResponse } from "./request_schema";
import type { RequestSchemaServiceFindBindingForAppEntitlementRequest } from "./request_schema";
import type { RequestSchemaServiceRemoveEntitlementBindingResponse } from "./request_schema";
import type { RequestSchemaServiceRemoveEntitlementBindingRequest } from "./request_schema";
import type { RequestSchemaServiceCreateEntitlementBindingResponse } from "./request_schema";
import type { RequestSchemaServiceCreateEntitlementBindingRequest } from "./request_schema";
import type { RequestSchemaServiceRemoveEntitlementBindingsResponse } from "./request_schema";
import type { RequestSchemaServiceRemoveEntitlementBindingsRequest } from "./request_schema";
import type { RequestSchemaServiceCreateEntitlementBindingsResponse } from "./request_schema";
import type { RequestSchemaServiceCreateEntitlementBindingsRequest } from "./request_schema";
import type { RequestSchemaServiceSearchResponse } from "./request_schema";
import type { RequestSchemaServiceSearchRequest } from "./request_schema";
import type { RequestSchemaServiceUpdateResponse } from "./request_schema";
import type { RequestSchemaServiceUpdateRequest } from "./request_schema";
import type { RequestSchemaServiceListResponse } from "./request_schema";
import type { RequestSchemaServiceListRequest } from "./request_schema";
import type { RequestSchemaServiceFindByAppEntitlementResponse } from "./request_schema";
import type { RequestSchemaServiceFindByAppEntitlementRequest } from "./request_schema";
import type { RequestSchemaServiceGetResponse } from "./request_schema";
import type { RequestSchemaServiceGetRequest } from "./request_schema";
import type { RequestSchemaServiceDeleteResponse } from "./request_schema";
import type { RequestSchemaServiceDeleteRequest } from "./request_schema";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RequestSchemaServiceCreateResponse } from "./request_schema";
import type { RequestSchemaServiceCreateRequest } from "./request_schema";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.request_schema.v1.RequestSchemaService
 */
export interface IRequestSchemaServiceClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: RequestSchemaServiceCreateRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateRequest, RequestSchemaServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: RequestSchemaServiceDeleteRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceDeleteRequest, RequestSchemaServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: RequestSchemaServiceGetRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceGetRequest, RequestSchemaServiceGetResponse>;
    /**
     * @generated from protobuf rpc: FindByAppEntitlement
     */
    findByAppEntitlement(input: RequestSchemaServiceFindByAppEntitlementRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindByAppEntitlementRequest, RequestSchemaServiceFindByAppEntitlementResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: RequestSchemaServiceListRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceListRequest, RequestSchemaServiceListResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: RequestSchemaServiceUpdateRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceUpdateRequest, RequestSchemaServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: RequestSchemaServiceSearchRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceSearchRequest, RequestSchemaServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: CreateEntitlementBindings
     */
    createEntitlementBindings(input: RequestSchemaServiceCreateEntitlementBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateEntitlementBindingsRequest, RequestSchemaServiceCreateEntitlementBindingsResponse>;
    /**
     * @generated from protobuf rpc: RemoveEntitlementBindings
     */
    removeEntitlementBindings(input: RequestSchemaServiceRemoveEntitlementBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceRemoveEntitlementBindingsRequest, RequestSchemaServiceRemoveEntitlementBindingsResponse>;
    /**
     * @generated from protobuf rpc: CreateEntitlementBinding
     */
    createEntitlementBinding(input: RequestSchemaServiceCreateEntitlementBindingRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateEntitlementBindingRequest, RequestSchemaServiceCreateEntitlementBindingResponse>;
    /**
     * @generated from protobuf rpc: RemoveEntitlementBinding
     */
    removeEntitlementBinding(input: RequestSchemaServiceRemoveEntitlementBindingRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceRemoveEntitlementBindingRequest, RequestSchemaServiceRemoveEntitlementBindingResponse>;
    /**
     * @generated from protobuf rpc: FindBindingForAppEntitlement
     */
    findBindingForAppEntitlement(input: RequestSchemaServiceFindBindingForAppEntitlementRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindBindingForAppEntitlementRequest, RequestSchemaServiceFindBindingForAppEntitlementResponse>;
    /**
     * @generated from protobuf rpc: UpdateBindings
     */
    updateBindings(input: RequestSchemaServiceUpdateBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceUpdateBindingsRequest, RequestSchemaServiceUpdateBindingsResponse>;
    /**
     * @generated from protobuf rpc: FindForAppEntitlements
     */
    findForAppEntitlements(input: RequestSchemaServiceFindForAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindForAppEntitlementsRequest, RequestSchemaServiceFindForAppEntitlementsResponse>;
    /**
     * @generated from protobuf rpc: CountBindingsForSchema
     */
    countBindingsForSchema(input: RequestSchemaServiceCountBindingsForSchemaRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCountBindingsForSchemaRequest, RequestSchemaServiceCountBindingsForSchemaResponse>;
}
/**
 * @generated from protobuf service c1.api.request_schema.v1.RequestSchemaService
 */
export class RequestSchemaServiceClient implements IRequestSchemaServiceClient, ServiceInfo {
    typeName = RequestSchemaService.typeName;
    methods = RequestSchemaService.methods;
    options = RequestSchemaService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: RequestSchemaServiceCreateRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateRequest, RequestSchemaServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceCreateRequest, RequestSchemaServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: RequestSchemaServiceDeleteRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceDeleteRequest, RequestSchemaServiceDeleteResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceDeleteRequest, RequestSchemaServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: RequestSchemaServiceGetRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceGetRequest, RequestSchemaServiceGetResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceGetRequest, RequestSchemaServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FindByAppEntitlement
     */
    findByAppEntitlement(input: RequestSchemaServiceFindByAppEntitlementRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindByAppEntitlementRequest, RequestSchemaServiceFindByAppEntitlementResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceFindByAppEntitlementRequest, RequestSchemaServiceFindByAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: RequestSchemaServiceListRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceListRequest, RequestSchemaServiceListResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceListRequest, RequestSchemaServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: RequestSchemaServiceUpdateRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceUpdateRequest, RequestSchemaServiceUpdateResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceUpdateRequest, RequestSchemaServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: RequestSchemaServiceSearchRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceSearchRequest, RequestSchemaServiceSearchResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceSearchRequest, RequestSchemaServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateEntitlementBindings
     */
    createEntitlementBindings(input: RequestSchemaServiceCreateEntitlementBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateEntitlementBindingsRequest, RequestSchemaServiceCreateEntitlementBindingsResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceCreateEntitlementBindingsRequest, RequestSchemaServiceCreateEntitlementBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveEntitlementBindings
     */
    removeEntitlementBindings(input: RequestSchemaServiceRemoveEntitlementBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceRemoveEntitlementBindingsRequest, RequestSchemaServiceRemoveEntitlementBindingsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceRemoveEntitlementBindingsRequest, RequestSchemaServiceRemoveEntitlementBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateEntitlementBinding
     */
    createEntitlementBinding(input: RequestSchemaServiceCreateEntitlementBindingRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCreateEntitlementBindingRequest, RequestSchemaServiceCreateEntitlementBindingResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceCreateEntitlementBindingRequest, RequestSchemaServiceCreateEntitlementBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveEntitlementBinding
     */
    removeEntitlementBinding(input: RequestSchemaServiceRemoveEntitlementBindingRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceRemoveEntitlementBindingRequest, RequestSchemaServiceRemoveEntitlementBindingResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceRemoveEntitlementBindingRequest, RequestSchemaServiceRemoveEntitlementBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FindBindingForAppEntitlement
     */
    findBindingForAppEntitlement(input: RequestSchemaServiceFindBindingForAppEntitlementRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindBindingForAppEntitlementRequest, RequestSchemaServiceFindBindingForAppEntitlementResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceFindBindingForAppEntitlementRequest, RequestSchemaServiceFindBindingForAppEntitlementResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateBindings
     */
    updateBindings(input: RequestSchemaServiceUpdateBindingsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceUpdateBindingsRequest, RequestSchemaServiceUpdateBindingsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceUpdateBindingsRequest, RequestSchemaServiceUpdateBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: FindForAppEntitlements
     */
    findForAppEntitlements(input: RequestSchemaServiceFindForAppEntitlementsRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceFindForAppEntitlementsRequest, RequestSchemaServiceFindForAppEntitlementsResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceFindForAppEntitlementsRequest, RequestSchemaServiceFindForAppEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountBindingsForSchema
     */
    countBindingsForSchema(input: RequestSchemaServiceCountBindingsForSchemaRequest, options?: RpcOptions): UnaryCall<RequestSchemaServiceCountBindingsForSchemaRequest, RequestSchemaServiceCountBindingsForSchemaResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<RequestSchemaServiceCountBindingsForSchemaRequest, RequestSchemaServiceCountBindingsForSchemaResponse>("unary", this._transport, method, opt, input);
    }
}
